import { useShare } from '../hooks/useShare';

type ShareContainerProps = { children: React.ReactNode };

const ShareContainer = ({ children }: ShareContainerProps) => {
	const { blockClass, componentId } = useShare();

	return (
		<div data-selection={componentId}>
			<div className={`vtex-store-components-3-x-shareContainer ${blockClass ? blockClass : 'db'}`}>{children}</div>
		</div>
	);
};

export default ShareContainer;
